<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.AdditionalCostRemarks')"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form label-width="60px" label-position="left">
      <el-form-item :label="$t('FinanceManage.AdditionalCostRemarksContent')">
        <el-input
          v-model="remark"
          type="textarea"
          :rows="8"
          style="width: 200px;"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="ok">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'UpdateRemarkDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      remark: ''
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.remark = ''
      }
    }
  },
  methods: {
    ok() {
      if (!this.remark) {
        this.$message.warning(this.$t('Billing.billingCharge_remarks') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.$emit('returnCall', this.remark)
      this.innerVisible = false
    }
  }
}
</script>

